<template>
  <div class="orderdetails">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/myorder' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 详情 -->
    <el-card class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>基本详情</b>
        </div>
        <el-button-group>
          <el-button type="success" icon="el-icon-download" @click="getMaitou" >下载唛头</el-button>
          <el-button type="primary" @click="getRucangdan" icon="el-icon-download">入仓单</el-button>
        </el-button-group>
      </div>
      <div class="base-desc" v-if="orderBase">
        <div class="base-desc-item" v-for="item in baseDescItems" :key="item.label" :class="{ wide: item.wide }">
          <span class="base-desc-label">{{ item.label }}</span>
          <span class="base-desc-value" :title="item.value">{{ item.value || '—' }}</span>
        </div>
      </div>
      <div v-else class="base-desc-empty">暂无数据</div>
    </el-card>
    <!-- 左：费用+文件；右：物流进度高度对齐左侧 -->
    <div class="detail-side-by-side">
      <div class="detail-side-left" ref="sideLeft">
        <el-card class="main detail-fee-card">
          <div slot="header" class="clearfix">
            <div>
              <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
              <b>费用</b>
            </div>
          </div>
          <el-table :data="moneyData" style="width: 100%">
            <el-table-column prop="feeName" label="费用"></el-table-column>
            <el-table-column label="单价*数量">
              <template slot-scope="scope">
                {{scope.row.price}}*{{scope.row.num}}
              </template>
            </el-table-column>
            <el-table-column label="合计金额">
              <template slot-scope="scope">
                {{scope.row.money}} {{scope.row.currency}}
              </template>
            </el-table-column>
            <el-table-column prop="exchangeRate" label="汇率"></el-table-column>
            <el-table-column label="折合金额">
              <template slot-scope="scope">
                {{scope.row.toMoney}} {{scope.row.toCurrency}}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
          </el-table>
        </el-card>
        <el-card class="main detail-file-card">
          <div slot="header" class="clearfix">
            <div>
              <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
              <b>文件</b>
            </div>
          </div>
          <el-table :data="guanshuiData">
            <el-table-column prop="name" label="文件名"></el-table-column>
            <el-table-column label="上传时间">
              <template slot-scope="scope">
                {{scope.row.createTime | dateformat}}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link :href="scope.row.url" type="primary" target="_blank">下载</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
      <div class="detail-side-right">
        <el-card class="main detail-logistics-card" :style="logisticsCardStyle">
          <div slot="header" class="clearfix">
            <div>
              <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
              <b>物流进度</b>
            </div>
          </div>
          <el-timeline class="detail-logistics-timeline">
            <el-timeline-item
              v-for="(item, index) in schedule"
              :key="index"
              :icon="item.icon"
              :size="item.size"
              :type="item.type"
              :color="item.color"
            >
              <b>{{item.content}}</b>
              <span style="margin-left:15px">{{item.createTime|dateformat}}</span>
            </el-timeline-item>
          </el-timeline>
        </el-card>
      </div>
    </div>
    <!-- 材积：有数据才展示 -->
    <el-card v-if="volumeData && volumeData.length" class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>材积</b>
        </div>
      </div>
      <el-table :data="volumeData" style="width: 100%" show-summary :summary-method="getSummaries">
        <el-table-column type="index" label="序号" width="150"></el-table-column>
        <el-table-column prop="num" label="总件数CTN"></el-table-column>
        <el-table-column prop="realWeight" label="单箱实重"></el-table-column>
        <el-table-column prop="length" label="长CM"></el-table-column>
        <el-table-column prop="width" label="宽CM"></el-table-column>
        <el-table-column prop="height" label="高CM"></el-table-column>
        <el-table-column prop="weight" label="总实重"></el-table-column>
        <el-table-column prop="volumeWeight" label="体积重KG"></el-table-column>
        <el-table-column prop="volume" label="体积CBM"></el-table-column>
        <!-- <el-table-column prop="weightVolume" label="重量方CBM"></el-table-column> -->
        <el-table-column prop="finalsettle" label="结算重/方"></el-table-column>
      </el-table>
    </el-card>
    <!-- 产品申报：有数据才展示 -->
    <el-card v-if="brandData && brandData.length" class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>产品申报</b>
        </div>
      </div>
      <el-table :data="brandData" style="width: 100%">
        <el-table-column prop="name" label="中文名"></el-table-column>
        <el-table-column prop="ename" label="英文名"></el-table-column>
        <el-table-column label="合规提示" min-width="140">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row._riskHit" :content="scope.row._riskTip || '敏感品名，请人工复核'" placement="top">
              <div>
                <el-tag
                  v-for="(lb, ti) in (scope.row._riskLabels || [])"
                  :key="ti"
                  type="danger"
                  size="mini"
                  style="margin:1px"
                >{{ lb }}</el-tag>
              </div>
            </el-tooltip>
            <span v-else style="color:#c0c4cc">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="hscode" label="税号"></el-table-column>
        <el-table-column prop="material" label="材质"></el-table-column>
        <el-table-column prop="purpose" label="用途"></el-table-column>
        <el-table-column prop="unitValue" label="单价"></el-table-column>
        <el-table-column prop="qty" label="数量"></el-table-column>
        <el-table-column prop="totalValue" label="总价"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <el-image :src="scope.row.picUrl" style="width:50px"></el-image>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 取件方式：仅上门提货有数据时展示 -->
    <el-card v-if="trailerData && trailerData.length" class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>上门提货</b>
        </div>
      </div>
      <el-table :data="trailerData" style="width: 100%">
        <el-table-column prop="status" label="提货状态"></el-table-column>
        <el-table-column prop="driverCarNo" label="司机车牌号"></el-table-column>
        <el-table-column prop="driverName" label="司机"></el-table-column>
        <el-table-column prop="driverTel" label="司机电话"></el-table-column>
        <el-table-column label="提货时间" width="120">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.getsTime | dateformat
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="contact" label="供应商联系人" width="120"></el-table-column>
        <el-table-column prop="contactTel" label="供应商电话"></el-table-column>
        <el-table-column prop="contactAdd" label="供应商地址"></el-table-column>
        <el-table-column prop="remark" label=" 备注"></el-table-column>
      </el-table>
    </el-card>
    <!-- 预约号：仅有预约数据时展示（FBA 等） -->
    <el-card v-if="orderShip && orderShip.length" class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>预约号</b>
        </div>
      </div>
      <el-table :data="orderShip" style="width: 100%">
        <el-table-column prop="shipmentid" label="亚马逊预约单号"></el-table-column>
        <el-table-column prop="referenceid" label="亚马逊跟踪号"></el-table-column>
        <el-table-column prop="kg" label="重量/KG"></el-table-column>
        <el-table-column prop="ctn" label="件/CTN"></el-table-column>
        <el-table-column prop="cbm" label="体积/CBM"></el-table-column>
      </el-table>
    </el-card>
    <!-- 货箱信息：有箱才展示 -->
    <el-card v-if="boxList && boxList.length" class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-box" style="line-height:23px;margin:0 10px"></i>
          <b>货箱信息</b>
          <span style="color:#909399;font-size:12px;margin-left:8px">共 {{boxList.length}} 箱，一箱一个面单号</span>
        </div>
      </div>
      <el-table :data="boxList" style="width: 100%" v-loading="boxLoading" empty-text="暂无货箱信息">
        <el-table-column type="index" label="#" width="55" align="center"></el-table-column>
        <el-table-column prop="boxCode" label="箱号" min-width="170" show-overflow-tooltip></el-table-column>
        <el-table-column label="面单号" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.trackNumber">{{ scope.row.trackNumber }}</span>
            <span v-else style="color:#c0c4cc">待补充</span>
          </template>
        </el-table-column>
        <el-table-column prop="weightKg" label="实重KG" width="100"></el-table-column>
        <el-table-column prop="sizeTxt" label="尺寸CM" width="150"></el-table-column>
        <el-table-column prop="cbm" label="材积CBM" width="110"></el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      class="abnormal"
      title="唛头下载"
      :visible.sync="dialogFormVisible3"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="35%"
    >
      <div class="dialog-footer" style="text-align:center;">
        <el-select v-model="marks" clearable placeholder="请选择唛头模板"  value-key="id">
          <el-option
            v-for="(item,index) in options3"
            :key="index"
            :label="item.marks"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="getMaitou2()">单张唛头</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
import { applyGoodsRiskToRows } from "@/utils/goodsRisk";
import {
  mapTransportTimeLabels,
  resolveOrderTransportTimes
} from "@/util/orderTransportTime";
export default {
  data() {
    return {
      messageData: [],
      volumeData: [],
      brandData: [],
      trailerData: [],
      schedule: [],
      container: {
        etd: null,
        eta: null,
        pol: '',
        podEnd: '',},
      orderShip: [],
      options3: [],
      marks: {},
      moneyData: [],
      guanshuiData:[],
      dialogFormVisible3: false,
      finalsettle: "",//结算重
      weight: "",
      volumeWeight: "",
      volume: "",
      settleType: "",
      ctn:"",
      boxList: [],
      boxLoading: false,
      logisticsHeight: 0,
      _sideLeftObserver: null
    };
  },
  computed: {
    orderBase() {
      return (this.messageData && this.messageData[0]) || null;
    },
    baseDescItems() {
      const o = this.orderBase;
      if (!o) return [];
      const fmt = this.$options.filters.dateformat;
      const dash = (v) => {
        if (v === 0 || v === "0") return String(v);
        if (v == null || v === "") return "";
        return String(v);
      };
      const items = [
        { label: "运单号", value: dash(o.clientNo) },
        { label: "渠道", value: dash(o.channelName) },
        { label: "送货仓", value: dash(o.dispatchPlace) },
        { label: "件数", value: dash(o.ctn) },
        { label: "报关", value: dash(o.declareType) },
        { label: "清关", value: dash(o.clearanceModeTxt) },
        { label: "业务类型", value: dash(o.freightMethod) },
        { label: "取件", value: dash(o.pickupType) },
        { label: "订单状态", value: dash(o.orderStatus) },
        { label: "付款状态", value: dash(o.recStatus) },
        { label: "派送单号", value: dash(o.enLogno) },
        { label: "送货时间", value: o.dispatchTime ? fmt(o.dispatchTime) : "" },
        { label: "下单时间", value: o.createTime ? fmt(o.createTime) : "" },
        {
          label: "保险",
          value:
            o.insurance === "是" && o.insuranceFee
              ? `是 / ${o.insuranceFee} USD`
              : dash(o.insurance)
        },
        { label: "进口商", value: dash(o.impor) },
        { label: "发货人", value: dash(o.shipper) },
        { label: "收货地址", value: dash(o.address), wide: true },
        { label: "备注", value: dash(o.userRemark), wide: true }
      ];
      // 空值字段不占格，减少空白行感
      return items.filter((it) => it.wide || (it.value !== "" && it.value != null));
    },
    logisticsCardStyle() {
      if (!this.logisticsHeight) return {};
      return { height: this.logisticsHeight + "px" };
    },
    transportTimes() {
      return resolveOrderTransportTimes({
        container: this.container,
        order: this.messageData[0],
        logistics: this.schedule
      });
    },
    transportEtd() {
      return this.transportTimes.etd;
    },
    transportEta() {
      return this.transportTimes.eta;
    },
    transportTimeLabels() {
      const order = this.messageData[0];
      return mapTransportTimeLabels(order && order.transportModeCode);
    }
  },
  methods: {
    syncLogisticsHeight() {
      this.$nextTick(() => {
        const el = this.$refs.sideLeft;
        if (!el) return;
        const h = Math.round(el.getBoundingClientRect().height);
        if (h > 0 && h !== this.logisticsHeight) {
          this.logisticsHeight = h;
        }
      });
    },
    bindSideLeftObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.$nextTick(() => {
        const el = this.$refs.sideLeft;
        if (!el) return;
        if (this._sideLeftObserver) {
          this._sideLeftObserver.disconnect();
        }
        this._sideLeftObserver = new ResizeObserver(() => {
          this.syncLogisticsHeight();
        });
        this._sideLeftObserver.observe(el);
        this.syncLogisticsHeight();
      });
    },
    async refreshGoodsRisk() {
      try {
        const rows = this.brandData || [];
        const goodsList = rows.map((g) => ({ name: g.name, ename: g.ename }));
        if (!goodsList.length) return;
        const country = (this.messageData[0] && this.messageData[0].shipmentCountry) || '';
        const res = await httpApi.goodsRiskCheck({ country, goodsList });
        if (res.data.code !== 'ok') return;
        applyGoodsRiskToRows(rows, res.data.data || {}, this.$set.bind(this));
      } catch (e) { /* ignore */ }
    },
    //下载唛头
    getMaitou() {
      this.dialogFormVisible3 = true;
      this.init3();
    },
    getMaitou2(type) {
      let typeFlag = type ? "a4" : "";
      this.dialogFormVisible3 = false;
      window.open(
        this.mApi +
          "report/mai_tou3?orderNo=" + this.$route.params.orderNo + "&type=" + typeFlag + "&marksModel=" + this.marks.marksModel +"&suffix="+this.marks.suffix+"&serialNum="+this.marks.serialNum+"&isHasSuffix="+this.marks.isHasSuffix
      );
    },
    init3() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_marks",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options3 = res.data.data;
          }
        });
    },
    //下载入仓单
    getRucangdan() {
      window.open(
        this.mApi + "report/ru_cang_dan?orderNo=" + this.$route.params.orderNo
      );
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return "warning-row";
      }
      return "";
    },
    //货箱信息(箱↔面单号)
    loadBox() {
      const that = this;
      that.boxLoading = true;
      httpApi.listOrderBox({ params: { orderNo: that.$route.params.orderNo } }).then(res => {
        if (res.data.code === "ok") {
          that.boxList = res.data.data || [];
        }
      }).catch(() => {}).finally(() => {
        that.boxLoading = false;
      });
    },
    init() {
      let that = this;
      httpApi
        .findOrder({
          params: { orderNo: that.$route.params.orderNo }
        })
        .then(res => {
          if (res.data.code == "ok") {
            //基本信息
            that.messageData.push(res.data.data.findOrderResponse);
            //柜子信息
            if (res.data.data.findContainerResponse) {
              that.container = res.data.data.findContainerResponse;
            }
            //材积
            that.volumeData = res.data.data.findOrderVolumeResponseList;
            //操作进度
            that.schedule = res.data.data.findOrderLogisticsResponseList;
            //品牌
            that.brandData = res.data.data.findOrderGoodsResponseList || [];
            that.refreshGoodsRisk();
            //取件方式
            that.trailerData = res.data.data.findOrderTrailerResponseList;
            //预约号
            that.orderShip = res.data.data.findOrderShipmentResponseList;
            //金额
            that.moneyData = res.data.data.findOrderSettleResponseList;
            //关税
            that.guanshuiData = res.data.data.findOrderFileResponseList;
            //品牌！！！！！
            //品牌类型
            for (let i in that.brandData) {
              if (that.brandData[i].brandType == 0) {
                that.brandData[i].brandType = "无品牌";
              } else if (that.brandData[i].brandType == 1) {
                that.brandData[i].brandType = "境内自主品牌";
              } else if (that.brandData[i].brandType == 2) {
                that.brandData[i].brandType = "境内收购品牌";
              } else if (that.brandData[i].brandType == 3) {
                that.brandData[i].brandType = "境外品牌（贴牌生产）";
              } else {
                that.brandData[i].brandType = "境外品牌（其他）";
              }
            }
            //取件方式!!!!!
            //提货状态
            for (let i in that.trailerData) {
              if (that.trailerData[i].status == 0) {
                that.trailerData[i].status = "待提货";
              } else {
                that.trailerData[i].status = "已提货";
              }
            }
            //结算重
            that.ctn=that.messageData[0].realCtn
            that.finalsettle = that.messageData[0].finalsettle
            that.weight = that.messageData[0].realKg
            that.volumeWeight = that.messageData[0].volumeWeight
            that.volume = that.messageData[0].realCbm
            that.settleType = that.messageData[0].settleTypeTxt
            //详情！！！！！
            //发货人
            let ship = "";
            ship =
              that.messageData[0].shipperName +
              that.messageData[0].shipperAddress;
            that.messageData[0].shipper = ship;
            //收货地址
            let arr = "";
            arr =
              that.messageData[0].shipmentContact +
              that.messageData[0].shipmentCountry +
              that.messageData[0].shipmentState;

            //地址类型判断
            if (that.messageData[0].shipmentType == 0) {
              that.messageData[0].shipmentType = "fba地址";
              that.messageData[0].address = that.messageData[0].shipmentAddress;
            } else {
              that.messageData[0].shipmentType = "私人地址"; //需要拼接
              that.messageData[0].address =
                that.messageData[0].shipmentAddress + arr;
            }
            //报关判断（文案与 DeclareTypeEnum 对齐）
            const declareMap = {
              "0": "买单",
              "1": "0110退税",
              "3": "自拖自报",
              "4": "合并报关",
              "8": "9610报关",
              "9": "9710报关",
              "10": "9810报关",
              "11": "1039市场采购"
            };
            const dCode = String(that.messageData[0].declareType);
            that.messageData[0].declareType = declareMap[dCode] || that.messageData[0].declareType;
            //保险状态判断
            if (that.messageData[0].insurance == 0) {
              that.messageData[0].insurance = "否";
            } else {
              that.messageData[0].insurance = "是";
            }
            //保险状态判断
            if (that.messageData[0].insuranceFee == 0) {
              that.messageData[0].insuranceFee = "";
            }
            //取件方式判断
            if (that.messageData[0].pickupType == 0) {
              that.messageData[0].pickupType = "自送货";
            } else {
              that.messageData[0].pickupType = "上门提货";
            }
            //业务类型判断
            if (that.messageData[0].freightMethod == 0) {
              that.messageData[0].freightMethod = "拼柜";
            } else {
              that.messageData[0].freightMethod = "整柜";
            }
            //进口商类型
            if (that.messageData[0].importerType == 0) {
              that.messageData[0].impor =
                that.messageData[0].importerAddress +
                that.messageData[0].importerName +
                that.messageData[0].importerTel;
            } else {
              that.messageData[0].impor = "代理进口商";
            }
            that.messageData[0].clearanceModeTxt =
              that.messageData[0].clearanceModeTxt ||
              (String(that.messageData[0].clearanceMode) === "1" ? "单票单清" : "合单清");
          } else {
            that.$message.error(res.data.message);
          }
          //物流进度
          for (let i in that.schedule) {
            that.schedule[i].color = "";
            that.schedule[i].icon = "";
            that.schedule[i].size = "normal";
            that.schedule[0].color = "red";
            that.schedule[0].icon = "el-icon-success";
            that.schedule[0].size = "large";
          }
          that.syncLogisticsHeight();
        });
    },
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[1] = this.ctn
          sums[2] = ""
          sums[3] = ""
          sums[4] = ""
          sums[5] = ""
          sums[6] = this.weight
          sums[7] = this.volumeWeight
          sums[8] = this.volume
          sums[9] = this.finalsettle+this.settleType;
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    }
  },
  created() {
    this.init();
    this.loadBox();
  },
  mounted() {
    this.bindSideLeftObserver();
  },
  beforeDestroy() {
    if (this._sideLeftObserver) {
      this._sideLeftObserver.disconnect();
      this._sideLeftObserver = null;
    }
  },
  watch: {
    // 方法1 //监听路由是否变化
    $route(to, from) {
      //监听路由是否变化
      if (to.params.orderNo != from.params.orderNo) {
        this.messageData = [];
        this.$route.params.orderNo = to.params.orderNo;
        this.init(); //重新加载数据
        this.loadBox();
      }
    },
    moneyData() {
      this.syncLogisticsHeight();
    },
    guanshuiData() {
      this.syncLogisticsHeight();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-card__header {
  padding: 10px 20px;
}
/deep/.main .el-card__body {
  padding: 0px 20px 20px;
}
/deep/.main .el-card__header {
  background-color: #ebeef5;
}
.detail-side-by-side {
  display: flex;
  align-items: flex-start;
  gap: 2%;
  margin-top: 20px;
  /* 覆盖全局 .el-main .el-card { margin-top:20px }，否则左右差一截间距 */
  /deep/ .el-card {
    margin-top: 0;
  }
}
.detail-side-left {
  width: 49%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.detail-side-right {
  width: 49%;
}
.detail-logistics-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
  box-sizing: border-box;
  /deep/ .el-card__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }
}
.detail-logistics-timeline {
  flex: 1;
  min-height: 80px;
  margin-top: 12px;
  overflow-y: auto;
  padding-right: 8px;
}
.base-desc {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid #ebeef5;
  border-right: 0;
  border-bottom: 0;
  margin-top: 8px;
}
.base-desc-item {
  display: flex;
  min-height: 36px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  &.wide {
    grid-column: span 2;
  }
}
.base-desc-label {
  flex: 0 0 76px;
  padding: 6px 8px;
  background: #f5f7fa;
  color: #606266;
  font-size: 12px;
  line-height: 22px;
  border-right: 1px solid #ebeef5;
  box-sizing: border-box;
}
.base-desc-value {
  flex: 1;
  min-width: 0;
  padding: 6px 8px;
  font-size: 13px;
  line-height: 22px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.base-desc-item.wide .base-desc-value {
  white-space: normal;
  word-break: break-all;
}
.base-desc-empty {
  padding: 16px;
  color: #909399;
  text-align: center;
}
.mesCard {
  margin: 20px;
  margin-top: 30px;
}
.clearfix {
  text-align: left;
  margin-left: -10px;
  display: flex;
  line-height: 35px;
  height: 35px;
  .el-input {
    width: 150px !important;
  }
  span,
  button {
    margin-left: 20px;
  }
  i,
  b {
    font-size: 13px;
  }
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fff;
}
/deep/.schTable .el-table__header {
  display: none;
}
/deep/.el-table th > .cell {
  color: black;
}
/deep/.el-table .warning-row {
  color: red;
}
/deep/.el-timeline {
  margin-top: 20px;
  li:first-child .el-timeline-item__wrapper .el-timeline-item__content {
    color: red;
  }
  .el-timeline-item__tail {
    left: 7px;
  }
  .el-timeline-item__node--large {
    left: 1px;
  }
  .el-timeline-item__node--normal {
    left: 2px;
  }
}
</style>